module.exports = __webpack_public_path__ + "media/packs/images/transit/pol-46215ef49f8396826f136bd17a2abe0a.svg";